import ProductLove from 'components/Product/ProductLove/ProductLove';
import { withProductLoveProps } from 'viewModel/product/productLove/withProductLoveProps';

export default withProductLoveProps(ProductLove);
